(() => {
  /* ================================================================
     Second set offer (Marketer #1072, 9 Oct - 31 Dec 2026)
     Klient z unikalnym kodem OCTOBERSET-xxxx (z maila Klaviyo) kupuje butelke 50/100 ml
     i dostaje classic Discovery Set gratis. Od 16.10 rabat w Shopify to "£29 off na Discovery Set"
     BEZ warunku butelki (BXGY nie laczyl sie z voucherem £25) - warunek "musi byc butelka" pilnuje
     wiec TEN skrypt: DOKLADA zestaw, gdy kod jest w koszyku i jest butelka, i ZDEJMUJE kazdy
     Discovery Set (nasz albo dolozony recznie), gdy kod jest, a butelki nie ma.
     Nie zatrzyma kogos, kto wpisze kod dopiero w kasie - to lapie kontrola zamowien (Marketer #1072).
     Wzorzec: FreshExperienceSet.js (cart.js + SlideCart refresh), bez karty i bez A/B.
     ================================================================ */

  /* ---- KONFIG ---- */
  const CODE_PREFIX = 'OCTOBERSET';          // kody z Klaviyo: OCTOBERSET-XXXXXXXX
  const DS_HANDLE = 'discover-set';          // classic Discovery Set (SKU DS-010-CLAS), ten sam co na LP
  const DS_SKU = 'DS-010-CLAS';
  const PROP_LABEL = 'Your second set';      // widoczna wlasciwosc linii: "Your second set: free"
  const PROP_MARK = '_second_set_offer';     // ukryty marker naszej linii
  const BOTTLE_RE = /^(50|100)\s*ml/i;       // tytul wariantu: '50ml Perfume', '100ml Full Size Perfume'
  const BOTTLE_SKU_RE = /^PE-(050|100)-/i;
  const DECLINED_KEY = 'itb_second_set_declined';

  /* ---- Cart ---- */
  async function getCart(){
    try {
      const r = await fetch('/cart.js', { cache:'no-store', credentials:'same-origin' });
      return r.ok ? await r.json() : null;
    } catch(_) { return null; }
  }
  function hasOfferCode(cart){
    const codes = (cart && cart.discount_codes) || [];
    // UWAGA: nie patrzymy na d.applicable — bez zestawu w koszyku Shopify zglasza kod jako 'applicable: false'; sam prefiks wystarcza, dopiero nasz add.js czyni kod 'applicable'.
    return codes.some(d => d && typeof d.code === 'string' && d.code.toUpperCase().startsWith(CODE_PREFIX));
  }
  function isBottle(it){
    return BOTTLE_RE.test(it.variant_title || '') || BOTTLE_SKU_RE.test(it.sku || '');
  }
  function isDiscoverySet(it){
    const sku = (it.sku || '').toUpperCase();
    const h = (it.handle || '').toLowerCase();
    return sku === DS_SKU || h === DS_HANDLE || h === 'discovery-set' || h === 'discovery-set-1' || h === 'iconic-discovery-set';
  }
  function ourLine(cart){
    return (cart.items || []).find(it => it.properties && it.properties[PROP_MARK]);
  }

  /* ---- DS variant ---- */
  let DS_VARIANT = null;
  async function dsVariantId(){
    if (DS_VARIANT) return DS_VARIANT;
    try {
      const r = await fetch('/products/' + DS_HANDLE + '.js', { cache:'no-store', credentials:'same-origin' });
      if (!r.ok) return null;
      const p = await r.json();
      const v = (p.variants || []).find(x => x.available) || (p.variants || [])[0];
      DS_VARIANT = v ? v.id : null;
    } catch(_) { DS_VARIANT = null; }
    return DS_VARIANT;
  }

  /* ---- SlideCart refresh (jak w FreshExperienceSet.js) ---- */
  async function refreshCartUi(){
    await new Promise((resolve) => {
      if (typeof window.SLIDECART_UPDATE === 'function') {
        let done = false;
        try { window.SLIDECART_UPDATE(() => { done = true; resolve(); }); } catch(_){ resolve(); return; }
        setTimeout(() => { if (!done) resolve(); }, 800);
      } else { resolve(); }
    });
    ['cart:updated','itb:cart:refresh'].forEach(ev => {
      try { document.dispatchEvent(new CustomEvent(ev, { bubbles:true, cancelable:true })); } catch(_){}
    });
  }

  /* ---- Glowna regula ---- */
  let busy = false, sawOurLine = false;
  async function reconcile(){
    if (busy) return;
    busy = true;
    try {
      const cart = await getCart();
      if (!cart) return;
      const items = cart.items || [];
      const bottle = items.some(isBottle);
      const ours = ourLine(cart);
      const anyDs = items.some(isDiscoverySet);
      const code = hasOfferCode(cart);

      // kod jest, butelki nie ma, a w koszyku siedzi Discovery Set (nasz lub dolozony recznie)
      // -> zestaw wypada; inaczej kasa da go za £0 bez butelki (rabat nie ma juz warunku "buy")
      if (code && !bottle && anyDs) {
        for (const it of items.filter(isDiscoverySet)) {
          await fetch('/cart/change.js', {
            method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
            body: JSON.stringify({ id: it.key, quantity: 0 }), cache:'no-store', credentials:'same-origin'
          });
        }
        sawOurLine = false;
        await refreshCartUi();
        return;
      }

      if (ours) {
        sawOurLine = true;
        if (!bottle || !code) {
          // butelka wypadla (albo kod zniknal) -> zestaw znika razem z nia
          await fetch('/cart/change.js', {
            method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
            body: JSON.stringify({ id: ours.key, quantity: 0 }), cache:'no-store', credentials:'same-origin'
          });
          sawOurLine = false;
          await refreshCartUi();
        }
        return;
      }

      // koszyk bez butelki (np. wyczyszczony po zakupie) = zacznij od zera, to nie bylo odrzucenie
      if (!bottle) sawOurLine = false;
      // nasza linia byla i zniknela przy butelce w koszyku = klient ja usunal -> nie dokladaj w tej sesji
      if (sawOurLine && bottle) {
        try { sessionStorage.setItem(DECLINED_KEY, '1'); } catch(_){}
        sawOurLine = false;
      }
      let declined = false;
      try { declined = sessionStorage.getItem(DECLINED_KEY) === '1'; } catch(_){}

      if (code && bottle && !anyDs && !declined) {
        const vid = await dsVariantId();
        if (!vid) return;
        const props = {}; props[PROP_LABEL] = 'free'; props[PROP_MARK] = CODE_PREFIX;
        const r = await fetch('/cart/add.js', {
          method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ items:[{ id: Number(vid), quantity: 1, properties: props }] }),
          cache:'no-store', credentials:'same-origin'
        });
        if (r.ok) { sawOurLine = true; await refreshCartUi(); }
      }
    } catch(err) {
      console.warn('[SecondSetOffer]', err);
    } finally {
      busy = false;
    }
  }

  /* ---- Kiedy sprawdzac: po kazdej zmianie koszyka + otwarcie szuflady + start strony ---- */
  let timer = null;
  function schedule(delay){ clearTimeout(timer); timer = setTimeout(reconcile, delay || 350); }

  // przechwyc fetch/XHR do /cart/add|change|update|clear (motyw, SlideCart, inne skrypty)
  const CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const F = window.fetch;
  if (F) {
    window.fetch = function(input){
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const p = F.apply(this, arguments);
      if (CART_RE.test(url)) p.then(res => { if (res && res.ok) schedule(); }).catch(() => {});
      return p;
    };
  }
  const XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(m, u){ this.__itbUrl = u; return XO.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function(){
    if (CART_RE.test(String(this.__itbUrl || ''))) this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) schedule(); });
    return XS.apply(this, arguments);
  };

  ['cart:updated','itb:cart:refresh','ajaxProduct:added'].forEach(ev => document.addEventListener(ev, () => schedule(500)));

  // otwarcie SlideCart (klasa .open na overlayu) -> sprawdz
  function waitForElm(sel){
    return new Promise(resolve => {
      const e = document.querySelector(sel); if (e) return resolve(e);
      const mo = new MutationObserver(() => { const n = document.querySelector(sel); if (n) { mo.disconnect(); resolve(n); } });
      mo.observe(document.documentElement, { childList:true, subtree:true });
    });
  }
  waitForElm('.slidecarthq-overlay').then(o => {
    let wasOpen = false;
    const mo = new MutationObserver(() => {
      const now = o.classList.contains('open');
      if (now && !wasOpen) schedule(200);
      wasOpen = now;
    });
    mo.observe(o, { attributes:true, attributeFilter:['class'] });
  });

  // start: po wejsciu z linku /discount/CODE?redirect=... kod juz siedzi w koszyku -> sprawdz raz
  if (document.readyState === 'complete') schedule(1500);
  else window.addEventListener('load', () => schedule(1500));
})();
